<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
    <div fxFlex>{{ data.title || 'Select Audio File' }}</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <mat-dialog-content style="display: flex; align-items: stretch">
    <div fxFlex class="stretched-container" style="padding: 5px">
      <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <mat-label class="label-text" style="margin-bottom: 20px; display: block">Audio files</mat-label>
        <mat-accordion [multi]="true">
          <mat-radio-group
            aria-label="Select an option"
            fxLayout="column"
            fxLayoutGap="10px"
            [formControl]="fileOptionControl"
          >
            @for (group of groupKeys; track group) {
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ group }}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                @for (rec of availableFilesGrouped[group]; track rec) {
                  <mat-radio-button value="{{ rec.id }}">
                    <div fxLayout="column" fxLayoutGap="10px">
                      @if (rec.id != '-2' && rec.id != '-1' && rec.name != 'Current Holiday Greeting') {
                        <span class="label-text">{{ rec.name }}</span>
                      }

                      @if (rec.id != '-1' && rec.id != '-2') {
                        <audio controls src="{{ '/api/holiday-greetings/pre-audio/stream/' + rec.id }}"></audio>
                      }

                      @if (rec.id == '-1') {
                        <app-upload-custom-audio-file
                          #fileInput
                          name="upload-audio1"
                          id="upload-audio1"
                          (validationError)="onFileValidationError($event)"
                          (valueChanged)="onFileChanged($event)"
                        ></app-upload-custom-audio-file>
                      }

                      @if (rec.id == '-2') {
                        <button type="button" mat-raised-button color="primary" (click)="onTextToSpeech()">
                          Text To Audio Generator
                        </button>
                      }
                    </div>
                  </mat-radio-button>
                }
              </mat-expansion-panel>
            }
          </mat-radio-group>
        </mat-accordion>
      </form>
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions style="justify-content: flex-end">
    <button type="button" mat-stroked-button color="primary" (click)="onSubmit()">Save</button>
    <button type="button" mat-stroked-button [mat-dialog-close]="false">Close</button>
  </div>
</div>
